import router from "@/router";
import { useUserStore } from "@/stores/modules/user";
import { useAdminPermissionStore, hasRoutePermission } from "@/stores/modules/admin/permission";

// npm install --save nprogress
import nprogress from "nprogress";
// 引入进度条样式
import "nprogress/nprogress.css";
nprogress.configure({ showSpinner: false });

// 全局守卫: 项目当中任意路由切换都会触发的钩子
// 全局前置守卫
router.beforeEach(async (to, from, next) => {
    // 访问路由组件之前，进度条开始动
    nprogress.start();

    // 区分设置商城与后台的标题
    const isAdmin = to.path.startsWith("/pcadmin");
    const systemTitle = isAdmin ? "即时零售" : "晨光联盟商城";
    document.title = to.meta.title ? `${systemTitle}-${to.meta.title}` : systemTitle;

    const userStore = useUserStore();

    // 不刷新用户信息
    const unRefreshUrls = ["/refresh", "/login"];
    // 刷新用户信息
    if (!unRefreshUrls.includes(to.path)) {
        userStore.getUserMe().catch(() => {});
    }

    const isLoggedIn = !!(userStore.userInfo && userStore.userInfo?.type != 10);

    // ------------------ 已经登录了则不允许访问登录页面 ------------------
    const unRedirectUrls = ["/login"];
    if (isLoggedIn && unRedirectUrls.includes(to.path)) {
        next(from.fullPath || "/");
        return;
    }

    // ------------------------- 判断是否需要登录 -------------------------
    // 无论是后台页面 (isAdmin) 还是带有 to.meta.isLogin 的前台页面
    if (!isLoggedIn && (to.meta.isLogin || isAdmin)) {
        const redirectUrl = encodeURIComponent(to.fullPath);
        next("/login?redirect=" + redirectUrl);
        return;
    }

    // ------------------------- 后台动态路由挂载处理 -------------------------
    if (isLoggedIn && isAdmin) {
        const permissionStore = useAdminPermissionStore();
        if (!permissionStore.isRoutesLoaded || permissionStore.routes.length === 0) {
            try {
                const asyncRoutes = await permissionStore.generateRoutes();
                // 动态挂载到 AdminLayout 路由树下
                asyncRoutes.forEach((route) => {
                    router.addRoute("AdminLayout", route);
                });
                // 重新跳转确保动态路由生效
                next({ ...to, replace: true });
                return;
            } catch (err) {
                console.error("[Guard] 动态路由加载失败:", err);
            }
        }

        // ------------------------- 后台页面权限白名单拦截 -------------------------
        if (permissionStore.isRoutesLoaded) {
            const isPermitted = hasRoutePermission(
                { name: to.name, path: to.path },
                permissionStore.addRoutes
            );
            if (!isPermitted) {
                console.warn(`[Guard] 当前门店无权访问后台页面: ${to.path}，已重定向至首页`);
                next("/pcadmin/dashboard");
                return;
            }
        }
    }

    // ------------------------- 后台未知/注释路由兜底 -------------------------
    if (isAdmin && to.matched.length === 0) {
        next("/pcadmin/dashboard");
        return;
    }

    next();
});

// 全局后置守卫
router.afterEach(() => {
    nprogress.done();
});